module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_9016.c2127ea2.png";